import { render } from "./DestinationEmptyPlaceholder.vue?vue&type=template&id=5f3997f3"
import script from "./DestinationEmptyPlaceholder.vue?vue&type=script&setup=true&lang=js"
export * from "./DestinationEmptyPlaceholder.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/Destination/DestinationEmptyPlaceholder.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "5f3997f3"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('5f3997f3', __exports__)) {
    api.reload('5f3997f3', __exports__)
  }
  
  module.hot.accept("./DestinationEmptyPlaceholder.vue?vue&type=template&id=5f3997f3", () => {
    api.rerender('5f3997f3', render)
  })

}


export default __exports__